import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';
import { musicServiceMessages } from '../messages';

export const youtubeMusic: MusicService = {
  id: 'youtube-music',
  name: 'YouTube Music',
  shortName: 'YouTube Music',
  isSupported: true,
  isComingSoon: false,
  areStatsSupported: false,
  areStatsComingSoon: false,
  isAlbumTransferSupported: false,
  color: {
    primary: '#FF0000',
    label: '#FF0000',
    background: '#8a6664',
  },
  importerID: ImporterID.YouTubeMusic,
  musicAPIID: MusicAPIIntegrationID.YoutubeMusic,
  linkType: 'youtubemusic',
  limits: {
    tracksPerPlaylist: 5000,
  },
  assets: {
    logo: { light: 'youtube-music-light.svg', dark: 'youtube-music-dark.svg' },
    logoPadding: {
      light: 'youtube-music-light-padding.svg',
      dark: 'youtube-music-dark-padding.svg',
    },
    logoColor: { light: 'youtube-music-color-light.svg', dark: 'youtube-music-color-dark.svg' },
    logoColorPadding: {
      light: 'youtube-music-color-light-padding.svg',
      dark: 'youtube-music-color-dark-padding.svg',
    },
    logoOnBackground: 'youtube-music-color-dark.svg',
  },
  whatIsDescription: musicServiceMessages.youtubeMusicWhatIs,
  /**
   * The same as YouTube: the YouTube Music importer and the partner API use the official YouTube
   * Data API with a Google OAuth login (a copy of the YouTube handlers). The unofficial YouTube
   * Music API is not used any more, so albums, adding to the liked songs and the listening
   * history (stats) are off until YouTube Music gets its own scopes on the same API.
   */
  authenticatedApiCapabilities: {
    doesSupportUpdatingPlaylists: true,
    doesSupportRemovingPlaylists: true,
    doesSupportRemovingTracks: true,
    doesSupportMovingTracks: true,
    doesSupportAddingTracksToLibrary: false,
    doesSupportRemovingTracksFromLibrary: false,
    doesSupportFetchingLibraryAlbums: false,
    doesSupportFetchingAlbums: false,
    doesSupportFetchingAlbumTracks: false,
    doesSupportAddingAlbums: false,
    doesSupportRemovingAlbums: false,
    doesSupportFetchingLibraryArtists: false,
    doesSupportFetchingArtists: false,
    doesSupportAddingArtistsToLibrary: false,
    doesSupportRemovingArtistsFromLibrary: false,
    doesSupportSearchByISRC: false,
    doesReturnISRC: false,
    doesReturnPreviewURL: false,
    doesReturnUserEmail: true,
    doesReturnUserCountry: false,
    maxLimit: 50,
  },
};
